function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBuoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 21.166666 21.166667",
    id: "svg19093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-275.83332)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.21950617,
      strokeOpacity: 1
    },
    id: "rect4518-85-4-2-0",
    width: 21.166666,
    height: 21.166666,
    x: -3.5527137e-15,
    y: 275.83331,
    rx: 10.583333,
    ry: 10.583333
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#d4ae26",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19206792,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-7-1-8",
    width: 18.520834,
    height: 18.520834,
    x: 1.3229218,
    y: 277.15622,
    rx: 9.260417,
    ry: 9.260417
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.13229166,
      strokeOpacity: 1
    },
    d: "m 5.9531186,293.03125 c -2.25224,0 -2.25295,-2.11667 -4.63021,-2.11667 v -2.11666 c 2.36399,0 2.93318,2.11667 4.63021,2.11667 1.69702,0 2.26621,-2.11667 4.6301994,-2.11667 2.364,0 2.8417,2.11667 4.63021,2.11667 1.85532,0 2.26622,-2.11667 4.63021,-2.11667 v 2.11666 c -2.37726,0 -2.37798,2.11667 -4.63021,2.11667 -2.25223,0 -2.65385,-2.11667 -4.63021,-2.11667 -1.9095394,0 -2.3779694,2.11667 -4.6301994,2.11667 z",
    id: "rect6560-6-4-2-1-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.58373493,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 10.186453,279.27293 -0.2645834,3.70416 h -0.661461 l -1.322916,1.5875 v 2.11667 h -3.96875 v 1.45521 l 2.328539,1.68672 c 1.441599,-0.25925 2.089783,-2.0836 4.2860444,-2.0836 2.20301,0 2.76879,1.83633 4.282942,2.0867 l 2.331641,-1.68982 v -1.45521 h -3.96875 v -2.11667 l -1.322917,-1.5875 -0.661455,1e-5 -0.264584,-3.70417 z",
    id: "rect5453"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuoy);
export default __webpack_public_path__ + "static/media/icon-buoy.6e39a783f5f28bc23910e2e9732e343f.svg";
export { ForwardRef as ReactComponent };